import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Button } from "primeng/button";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { UserService } from "@/_services";
import { OnboardingGuideService } from "@/_services/onboarding-guide.service";

export type PromotionalCardType = "acsf" | "manual";

@Component({
    selector: "app-promotional-card",
    standalone: true,
    imports: [CommonModule, Button, SharedComponentsModule],
    templateUrl: "./promotional-card.component.html",
    styleUrls: ["./promotional-card.component.scss"],
})
export class PromotionalCardComponent {
    @Input() cardType: PromotionalCardType = "manual";
    @Output() hidden = new EventEmitter<void>();

    constructor(
        private userService: UserService,
        private onboardingGuideService: OnboardingGuideService,
    ) {}

    dismiss() {
        const bannerKey = this.cardType === "acsf" ? "acsfCard" : "manualPromo";
        this.userService
            .dismissBanner(bannerKey, true)
            .subscribe(() => this.hidden.emit());
    }

    startGuide(event: Event) {
        event?.preventDefault();
        this.onboardingGuideService.open(event);
    }
}
